<template>
    <div class="skeleton-video skeleton-el">
        <div class="block1 block"></div>
        <ul class="block2">
            <li class="block"></li>
            <li class="block"></li>
            <li class="block"></li>
            <li class="block"></li>
        </ul>
        <div class="block3 block"></div>
        <ul class="block4">
            <li>
                <div class="block"></div>
                <div>
                    <div>
                        <div class="block"></div>
                        <div class="block"></div>
                    </div>
                    <div class="block"></div>
                    <div class="block"></div>
                </div>
                <div class="block"></div>
            </li>
            <li>
                <div class="block"></div>
                <div>
                    <div>
                        <div class="block"></div>
                        <div class="block"></div>
                    </div>
                    <div class="block"></div>
                    <div class="block"></div>
                </div>
                <div class="block"></div>
            </li>
            <li>
                <div class="block"></div>
                <div>
                    <div>
                        <div class="block"></div>
                        <div class="block"></div>
                    </div>
                    <div class="block"></div>
                    <div class="block"></div>
                </div>
                <div class="block"></div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'SkeletonAllTop',
};
</script>
<style lang="scss" scoped>
.skeleton-video {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    .block {
        background: #F0F0F0;
    }
}
.block1 {
    height: 226px;
}
.block2 {
    @include SpaceBetween();
    margin: 30px 70px 0;
    li {
        width: 120px;
        height: 103px;
    }
}
.block3 {
    width: 710px;
    height: 120px;
    margin: 20px auto 0;
}
.block4 {
    margin: 30px 50px 0;
    li {
        @include SpaceBetween();
        align-items: center;
        margin-bottom: 60px;
    }
    li > div {
        &:first-child {
            width: 134px;
            height: 134px;
            border-radius: 50%;
        }
        &:nth-child(2) {
            margin-top: 5px;
            & > div {
                &:first-child {
                    display: flex;
                    div:first-child {
                        width: 132px;
                        height: 36px;
                        border-radius: 18px;
                        margin-right: 8px;
                    }
                    div:last-child {
                        width: 60px;
                        height: 30px;
                        border-radius: 15px;
                    }
                }
                &:nth-child(2) {
                    width: 86px;
                    height: 26px;
                    border-radius: 13px;
                    margin: 15px 0 24px;
                }
                &:last-child {
                    width: 350px;
                    height: 28px;
                    border-radius: 14px;
                }
            }
        }
        &:last-child {
            width: 110px;
            height: 50px;
            border-radius: 25px;
        }
    }
}
</style>
